export enum LABEL_INPUT_TYPE {
  NUMBER = 0,
  TEXT = 1,
  RANGE = 2,
  LIST = 3,
}

export const labelInputTypeChoices = [
  { id: LABEL_INPUT_TYPE.NUMBER, name: 'Number' },
  { id: LABEL_INPUT_TYPE.TEXT, name: 'Text' },
  { id: LABEL_INPUT_TYPE.RANGE, name: 'Range' },
  { id: LABEL_INPUT_TYPE.LIST, name: 'List' },
];

export function getLabelInputTypeName(inputType: number | null | undefined): string {
  return labelInputTypeChoices.find((choice) => choice.id === inputType)?.name ?? 'Unknown';
}
